/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
function getTrustedOrigin(defaultPath) {
    if (typeof window !== 'undefined') {
        if (!window.location.origin?.toLowerCase()?.includes('localhost')) {
            return window.location.origin;
        }
    }
    return defaultPath;
}

export default getTrustedOrigin;
